import { ChartData } from "../../Editor/Displays/Chart";


export function renderBarChart(data:ChartData, chartData){
    
    chartData.series = [{
        name: data.names[0],
        data: data.values[0].map(Number)
    }];
    chartData.xaxis = {
        categories: data.labels
    }
    chartData.stroke = {
        width: 1
    }
    chartData.dataLabels = {
        "enabled": false,
        "textAnchor": "middle",
        "distributed": false,
        "offsetX": 0,
        "offsetY": 0,
        "style": {
            "fontSize": "12px",
            "fontWeight": 600,
            "colors": [
                "#fff"
            ]
        },
        "background": {
            "enabled": true,
            "foreColor": "#fff",
            "borderRadius": 2,
            "padding": 4,
            "opacity": 0.9,
            "borderWidth": 1,
            "borderColor": "#fff",
            "dropShadow": {
                "enabled": false,
                "top": 1,
                "left": 1,
                "blur": 1,
                "color": "#000",
                "opacity": 0.45
            }
        },
        "dropShadow": {
            "enabled": false,
            "top": 1,
            "left": 1,
            "blur": 1,
            "color": "#000",
            "opacity": 0.45
        }
    }
    chartData.legend = {
        show: false,
    }
    chartData.fill = {
        "type": "solid",
        "opacity": 0.85,
        "gradient": {
            "shade": "dark",
            "type": "horizontal",
            "shadeIntensity": 0.5,
            "inverseColors": true,
            "opacityFrom": 1,
            "opacityTo": 1,
            "stops": [
                0,
                50,
                100
            ],
            "colorStops": []
        },
        "image": {
            "src": []
        },
        "pattern": {
            "style": "squares",
            "width": 6,
            "height": 6,
            "strokeWidth": 2
        }
    }
    chartData.tooltip = {
        "enabled": true,
        "shared": true,
        "followCursor": false,
        "intersect": false,
        "inverseOrder": false,
        "fillSeriesColor": false,
        "theme": "light",
        "style": {
            "fontSize": "12px"
        },
        "onDatasetHover": {
            "highlightDataSeries": false
        },
        "x": {
            "show": true,
            "format": "dd MMM"
        },
        "y": {
            "title": {}
        },
        "z": {
            "title": "Size: "
        },
        "marker": {
            "show": true
        },
        "items": {
            "display": "flex"
        },
        "fixed": {
            "enabled": false,
            "position": "topRight",
            "offsetX": 0,
            "offsetY": 0
        }
    }
    return chartData;
    
}
